import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import FizConfig from "../FizConfig.ts";
import {ColorCache} from "../server/objects/ColorBean.ts";
import Icons from "../svg/Icons.ts";
import { notadminmodal } from "../global_connected.ts";
import { markDirty } from "../util/forms.ts";
import MultiplexApi from "../server/MultiplexApi.ts";

Html.registerWidget('widget/color-picker',{initDom})

async function initDom(domNode : HTMLElement){
  var
    
    visibilityPilot = domNode.closest('form')[domNode.getAttribute('data-visibility-pilot')] as HTMLInputElement,
    hasDefault = domNode.getAttribute('data-no-default')!=='true',
    defaultColor = domNode.getAttribute('data-default-color'),
    currentColor = domNode.getAttribute('data-color');

  if(visibilityPilot){
    visibilityPilot.addEventListener('change',function(){
      if(this.value==='true'){
        domNode.style.display = 'block'
      }else{
        domNode.style.display = 'none'
      }
    })
    visibilityPilot.dispatchEvent(new Event('change',{bubbles:true}))

  }

  function rewriteColor(colorsFromDb){
    var
      result = [];
    if(hasDefault){
      if(defaultColor){
        result.push({cc:defaultColor,name:i18n.get('color.default'),metaId:'color/-0',isDefault:true})
      }else{
        result.push({cc:FizConfig.defaultColor,name:i18n.get('color.default'),metaId:'color/-0',isDefault:true})
      }
    }

    if(currentColor && !colorsFromDb.find(c=>c.cc===currentColor) && !result.find(c=>c.cc===currentColor)){
      //if the currentcolor is not in the list we replace the first one by the current
      result.pop();
      result.push({cc:currentColor,name:i18n.get('color.default'),metaId:'color/-1',isDefault:true})
    }

    result = result.concat(colorsFromDb.filter(colorBean=>colorBean.cc!==result[0]?.cc));
    return result;

  }
  if(domNode.getAttribute('data-colors')){
    initWithColors(domNode,domNode.getAttribute('data-colors').split(',').map((str,idx)=>{return {cc:str,metaId:idx+''}}));
  }else {
    var colorsFromDb = await ColorCache.need()
    initWithColors(domNode,rewriteColor(colorsFromDb))
    
  }

}

function initWithColors(domNode,colors : {cc:string,name?:string,metaId:string,isDefault?:boolean}[]){
  var
    emptyDefault = domNode.getAttribute('data-default')==='empty',
    form = domNode.closest('form'),
    inputedColorString = domNode.getAttribute('data-color')||'',
    color = colors.filter(c=>c.cc===inputedColorString.toUpperCase())[0]||colors[0],
    initialSelected = color,
    context = {
      title:i18n.get('color.title'),
      selected:color,
      colors:colors,
      showhead:domNode.getAttribute('data-showhead')==='true'
    }

  function display(){
    let head = `
      <span class="label">${context.title}</span> : <span class="color-picker-text" data-fw-meta-id="${context.selected.metaId}" style="padding:0 8px 0 2px;cursor:pointer;color:${context.selected.cc};display:inline-block">${Html.escape(context.selected.name)}</span>
      ${context.selected.isDefault?'':`<i style="cursor:pointer;font-size:inherit;position:relative;top:-4px;left:-5px;color:${context.selected.cc}">${Icons.ic_edit}</i>`}
      <br/>`

    let colorByLines = [];
    if(context.colors.length>15){
      let half = Math.ceil(context.colors.length/2);
      colorByLines.push(context.colors.slice(0,half));
      colorByLines.push(context.colors.slice(half));
    }else{
      colorByLines.push(context.colors);
    }

    domNode.innerHTML = `<input name="color" type="hidden" value="${emptyDefault?(context.selected.isDefault?'':context.selected.cc):context.selected.cc}">
      ${context.showhead?head:''}
      ${colorByLines.map(colors=>`
        <ul class="color-picker" style="margin-bottom:5px">
          ${colors.map(c=>`
            <li ${c.isDefault?`data-color-default="true"`:''} data-color="${c.cc}" style="border-color:${c.cc};background-color:${c===context.selected?c.cc:''}" data-fw-meta-id="${c.metaId}"></li>
          `).join('')}
         </ul>
      `).join('')}
    `;

    //if external change of the hidden color input
    const inputElement = domNode.querySelector('input') as HTMLInputElement;
    //the input is rebuilt at each display so the change has to be flagged explicitly
    markDirty(inputElement,context.selected!==initialSelected);
    inputElement.addEventListener('change', function(){
      const li = domNode.querySelector(`li[data-color='${this.value}']`) as HTMLElement;
      if(li) li.click();
    });

    //change data
    form.style.setProperty('--fwPrimary', context.selected.cc);
  }
  display();

  domNode.addEventListener('click', function(evt){
    const target = evt.target as HTMLElement;
    const li = target.closest('li');
    if(li){
      const metaId = li.getAttribute('data-fw-meta-id');
      context.selected = colors.filter(c=>c.metaId===metaId)[0];
      display();
    }
  });

  domNode.addEventListener('click', function(evt){
    const target = evt.target as HTMLElement;
    const isIcon = target.closest('i');
    const isText = target.closest('.color-picker-text');
    if(!isIcon && !isText) return;

    const theNode = domNode.querySelector('.color-picker-text') as HTMLElement;
    if(theNode.contentEditable==='true') return;
    if(context.selected.isDefault) return;

    // Check permissions before allowing edit
    const metaId = theNode.getAttribute('data-fw-meta-id');
    const originalColor = ColorCache.get(metaId);
    if(!originalColor){
      MultiplexApi.webjslog("no color with metaId "+metaId);
      return;
    }
    if(!originalColor.rights.canUpdate){
      notadminmodal();
      return;
    }

    theNode.contentEditable = 'true';
    theNode.style.cursor = '';

    theNode.addEventListener('keydown', function(event) { //emulate maxlength
      if(this.innerText.length >= 30 && [37,39,8,46,10,13].indexOf(event.keyCode)== -1) { //allowed keycode 37 39 => arrow 8=>delete 46=>suppr 10,13=>return
        event.preventDefault();
      }
    });

    theNode.addEventListener('paste', function(event) {
      if(this.innerText.length >= 30) {
        event.preventDefault();
      }
    });

    theNode.focus();

    var range = document.createRange();
    range.selectNodeContents(theNode);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    async function onBlur(this: HTMLElement){
      let
        text = this.innerText.trim().replace(/\s+/g,' ');

      //if the text has changed
      if(text!==originalColor.name){
        if(!text.length || text===originalColor.defaultName){
          colors.find(c=>c.metaId===metaId).name = originalColor.defaultName
          MultiplexApi.colordelete([metaId]);
        }else{
          //else we update the color
          colors.find(c=>c.metaId===metaId).name = text
          MultiplexApi.colorput(new ApiServer.types.ColorInputBean({name:text,metaId:metaId}));
        }
        ColorCache.refresh()
      }
    }

    theNode.addEventListener('keypress', function(evt){
      if([10,13].indexOf(evt.keyCode)!==-1){
        evt.stopPropagation();
        evt.preventDefault();
        onBlur.call(this);
      }
    });

    theNode.addEventListener('blur', onBlur);
  });

  var defaultColor;
  form.addEventListener("pickedaccounts",function(evt){
    var
      data = evt.detail,
      color,
      defaultColorNode = domNode.querySelector('li[data-color-default]') as HTMLElement;

    if(!defaultColorNode) return;

    const bgColor = window.getComputedStyle(defaultColorNode).backgroundColor;
    const borderColor = window.getComputedStyle(defaultColorNode).borderColor;
    const isSelected = (bgColor === borderColor);

    defaultColor = defaultColor || defaultColorNode.getAttribute('data-color');

    if(!data.isAll && data.accounts.length===1){
      color = data.accounts[0].color;
    }else{
      color = defaultColor
    }

    defaultColorNode.setAttribute('data-color', color);
    defaultColorNode.style.borderColor = color;
    if(isSelected){
      defaultColorNode.style.backgroundColor = color;
    }

  })
}